import { get, find } from 'lodash';

// Dual View默认设置
export const DUAL_VIEW_SETTING_DEFAULT_LIST = {
    left: ['abst', 'clms', 'desc', 'figures', 'pdf'],
    right: ['abst', 'clms', 'desc', 'figures', 'pdf']
};
export const DUAL_VIEW_SETTING_DEFAULT_DISPLAY = {
    left: 'abst',
    right: 'figures'
};

export const getDualViewDisplayTabBySide = (originData, side) => {
    const result = [];
    const sideData = get(originData, side, []);
    sideData.forEach(item => {
        if (item.is_selected) result.push(item.name);
    });
    return result.length ? result : DUAL_VIEW_SETTING_DEFAULT_LIST[side];
};

export const getDualViewDefaultTab = (originData) => {
    const leftSide = get(originData, 'left', []);
    const rightSide = get(originData, 'right', []);
    const leftDefault = find(leftSide, item => item.is_default);
    const rightDefault = find(rightSide, item => item.is_default);
    return {
        left: get(leftDefault, 'name', DUAL_VIEW_SETTING_DEFAULT_DISPLAY.left),
        right: get(rightDefault, 'name', DUAL_VIEW_SETTING_DEFAULT_DISPLAY.right)
    };
};
